export const restNotification = {
  methods: {
    getNotificationsPages(
      page,
      search = '',
      size = 10,
      status = 'todos',
      sortKey = '',
      sortOrder = 'asc'
    ) {
      const backendurl = this.$store.getters.backendurl

      const params = new URLSearchParams({
        page,
        limit: size,
        status
      })

      if (search) {
        params.set('search', search)
      }

      if (sortKey) {
        params.set('sort', sortKey)
        params.set('order', sortOrder)
      }

      return this.$http
        .get(
          `${backendurl}api/v1/notifications?${params.toString()}`
        )
        .then((response) => {
          const data = response.data || {}
          const pagination = data.pagination || {}

          this.notifications = data.notifications || []
          this.totalPages = pagination.total_pages || 0
          this.totalNotifications = pagination.total || 0
        })
        .catch((error) => {
          console.error(error)

          this.notifications = []
          this.totalPages = 0
          this.totalNotifications = 0

          this.notificationsError =
            error.response?.data?.message ||
            'No fue posible obtener las notificaciones.'
        })
    },
    postNotification(notification) {
      const backendurl =
        this.$store.getters.backendurl

      return this.$http.post(
        `${backendurl}api/v1/notifications`,
        notification
      )
    },

    patchNotificationStatus(
      notificationID,
      active
    ) {
      const backendurl =
        this.$store.getters.backendurl

      return this.$http.put(
        `${backendurl}api/v1/notifications/${notificationID}/active`,
        {
          active
        }
      )
    },

    deleteNotification(notificationID) {
      const backendurl =
        this.$store.getters.backendurl

      return this.$http.delete(
        `${backendurl}api/v1/notifications/${notificationID}`
      )
    },
    getNotificationByID(notificationID) {
      const backendurl =
        this.$store.getters.backendurl

      return this.$http.get(
        `${backendurl}api/v1/notifications/${notificationID}`
      )
    },

    putNotification(notificationID, notification) {
      const backendurl =
        this.$store.getters.backendurl

      return this.$http.put(
        `${backendurl}api/v1/notifications/${notificationID}`,
        notification
      )
    },
        getMyNotifications() {
        const backendurl =
            this.$store.getters.backendurl

        return this.$http.get(
            `${backendurl}api/v1/notifications/me`
        )
        },
  }
}